import React, { VFC } from 'react';
import styled from 'styled-components';
import { IIconProps } from './types';

const Wrapper = styled.div`
  display: block;
  margin: auto auto;
`;

const PlusIcon: VFC<IIconProps> = ({ color, size }) => (
  <Wrapper>
    <svg
      width={size}
      height={size}
      fill="none"
      viewBox="0 -2 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 6v12M18 12H6"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
      />
    </svg>
  </Wrapper>
);

export default PlusIcon;
